import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivities = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M19.8994 13.9464L26.1393 7.35547",
			stroke: "currentColor",
			strokeWidth: 1.94997,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M25.0986 23.8003H28.9986",
			stroke: "currentColor",
			strokeWidth: 1.94997,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_3",
			d: "M12.7498 29.0003L28.2378 12.6401C28.5014 12.3767 28.7053 12.0598 28.8357 11.7107C28.966 11.3616 29.0199 10.9886 28.9935 10.6169C28.9671 10.2452 28.8611 9.88351 28.6827 9.55635C28.5044 9.22919 28.2577 8.9442 27.9596 8.72068L20.6667 3.25037C20.4728 3.10871 20.2435 3.0235 20.0042 3.0042C19.7649 2.98491 19.5248 3.03228 19.3108 3.14106C19.0967 3.24984 18.917 3.41578 18.7915 3.62048C18.666 3.82518 18.5996 4.06064 18.5997 4.30076V6.90071C18.5998 7.45258 18.4242 7.99014 18.0984 8.43558C17.7726 8.88103 17.3135 9.21126 16.7876 9.37847L11.68 10.8695C11.4231 10.9572 11.2001 11.1231 11.0423 11.3438C10.8845 11.5646 10.7997 11.8292 10.7999 12.1006C10.5984 20.4114 8.09332 23.8004 5.59996 23.8004C4.91041 23.8004 4.2491 24.0744 3.76151 24.5619C3.27392 25.0495 3 25.7108 3 26.4004C3 27.0899 3.27392 27.7513 3.76151 28.2388C4.2491 28.7264 4.91041 29.0003 5.59996 29.0003H23.7997",
			stroke: "currentColor",
			strokeWidth: 1.94997,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivities;
